import { Button, Typography } from '@iheartjane/reefer';
import isUndefined from 'lodash-es/isUndefined';
import { useState } from 'react';

import { FilterButtonGrid } from '../filter.styles';
import type { ProductFilterBarProps } from '../productFilterBar/productFilterBar.types';
import { ModalSection } from './modalSection';

type ProductFilterViewProps = Pick<
  ProductFilterBarProps,
  'listView' | 'onView'
>;

export const FilterModalViewSection = ({
  listView,
  onView,
}: ProductFilterViewProps) => {
  const [viewLabel, setViewLabel] = useState(listView ? 'List' : 'Grid');

  const viewOptions = [
    {
      label: 'Grid',
    },
    {
      label: 'List',
    },
  ];
  return (
    <div data-testid="filter-modal-section">
      <ModalSection title="View">
        <FilterButtonGrid itemsPerRow={2} mobileItemsPerRow={2}>
          {viewOptions.map((option) => (
            <Button
              key={option.label}
              label={
                <Typography
                  variant="body-semibold"
                  maxLines={2}
                  overflowWrap="anywhere"
                >
                  {option.label}
                </Typography>
              }
              onClick={() => {
                if (option.label !== viewLabel) {
                  onView && !isUndefined(listView) && onView(!listView);
                  setViewLabel(option.label);
                }
              }}
              variant={
                option.label === viewLabel ? 'tertiary-selected' : 'tertiary'
              }
              alignment="left"
              size="large"
              full
            />
          ))}
        </FilterButtonGrid>
      </ModalSection>
    </div>
  );
};
